
import { AreaBooking } from "../../classes"

const AreaBookingModule = {
  namespaced: true,
  state: {
    areaBookings: null,
    areaBooking: null
  },
  mutations: {
    setAreaBookings(state, bookings) {
      state.areaBookings = bookings || []
    },
    setAreaBooking(state, booking) {
      state.areaBooking = booking || []
    },
    clearAreaBookings(state) {
      state.bookings = null
    },
    clearAreaBooking(state) {
      state.booking = null
    },
  },
  actions: {
    createAreaBooking: async ({ commit }, formData) => {
      try {
        commit("clearAreaBooking")
        const data = await AreaBooking.createAreaBooking(formData)
        commit("setAreaBooking", data)
        return data
      } catch (error) {
        throw error
      }
    },
    editAreaBooking: async ({ commit }, formData) => {
      try {
        commit("clearAreaBooking")
        const data = await AreaBooking.editAreaBooking(formData)
        commit("setAreaBooking", data)
        return data
      } catch (error) {
        throw error
      }
    },
    checkInAreaBooking: async ({ commit }, formData) => {
      try {
        commit("clearAreaBooking")
        const data = await AreaBooking.checkInAreaBooking(formData)
        commit("setAreaBooking", data)
        return data
      } catch (error) {
        throw error
      }
    },
    checkOutAreaBooking: async ({ commit }, formData) => {
      try {
        commit("clearAreaBooking")
        const data = await AreaBooking.checkOutAreaBooking(formData)
        commit("setAreaBooking", data)
        return data
      } catch (error) {
        throw error
      }
    },
    cancelAreaBooking: async ({ commit }, areaBookingId) => {
      try {
        commit("clearAreaBooking")
        const data = await AreaBooking.cancelAreaBooking(areaBookingId)
        commit("setAreaBooking", data)
        return data
      } catch (error) {
        throw error
      }
    },
    getAreaBookingByBooking: async ({ commit }, bookingId) => {
      try {
        commit("clearAreaBookings")
        const data = await AreaBooking.getAreaBookingByBooking(bookingId)
        commit("setAreaBookings", data)
        return data
      } catch (error) {
        throw error
      }
    },
    getAreaBookingBetweenDate: async ({ commit }, fromData) => {
      try {
        const data = await AreaBooking.getAreaBookingBetweenDate(fromData);
        commit("setAreaBookings", data);
        return data
      } catch (err) {
        throw err
      }
    },
    getAreaBookingByArea: async ({ commit }, areaId) => {
      try {
        // commit("clearAreaBookings")
        const data = await AreaBooking.getAreaBookingByArea(areaId)
        // commit("setAreaBookings", data)
        return data
      } catch (error) {
        throw error
      }
    },
    getAreaBookingCheckedInDateBetweenDate: async ({ commit }, fromData) => {
      try {
        const data = await AreaBooking.getAreaBookingCheckedInDateBetweenDate(fromData);
        commit("setAreaBookings", data);
        return data
      } catch (err) {
        throw err
      }
    },
  },
  getters: {
    getAreaBookings: state => state.areaBookings,
  },
};
export default AreaBookingModule;
